module.exports = __webpack_public_path__ + "static/img/3.8124a24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/3.png
// module id = Nq/l
// module chunks = 0